import React, { lazy, memo, Suspense } from "react";
import { EmptyData, fmtPrice, signed, TinyTrend } from "./shared";

/* recharts + its d3/lodash tail is ~a third of the app bundle. The verdict
 * must never wait on it, so the premium trace loads after first paint. */
const PremiumChart = lazy(() => import("./PremiumChart"));
const SpotChart = lazy(() => import("./PremiumChart").then((m) => ({ default: m.SpotChart })));

/* ATM CALL / PUT premium against its VWAP (the line the live rules confirm
 * entries on) plus the spot trace, from the page's in-memory series. */
const PremiumTracker = memo(function PremiumTracker({ series, data, view }) {
  const ce = data?.atm_premiums?.ce;
  const pe = data?.atm_premiums?.pe;
  const atmRows = (data?.chain || []).filter((row) => Number(row.strike) === Number(data?.atm));
  const ceRow = atmRows.find((row) => row.option_type === "CE");
  const peRow = atmRows.find((row) => row.option_type === "PE");
  return (
    <div className="p-3">
      <div className="mb-2 grid grid-cols-2 gap-2">
        <div className="rounded-lg border border-emerald-500/20 bg-emerald-500/[.06] p-2">
          <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-wider text-emerald-500"><span>ATM CALL</span><TinyTrend value={view.ceMomentum} /></div>
          <p className="mt-0.5 text-lg font-black text-emerald-200">₹{fmtPrice(ce, 1)}</p>
          <p className="text-[10px] text-slate-500">VWAP ₹{fmtPrice(ceRow?.premium_vwap, 1)} · 3m {signed(ceRow?.velocity?.["3m"])}</p>
        </div>
        <div className="rounded-lg border border-rose-500/20 bg-rose-500/[.06] p-2">
          <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-wider text-rose-500"><span>ATM PUT</span><TinyTrend value={view.peMomentum} /></div>
          <p className="mt-0.5 text-lg font-black text-rose-200">₹{fmtPrice(pe, 1)}</p>
          <p className="text-[10px] text-slate-500">VWAP ₹{fmtPrice(peRow?.premium_vwap, 1)} · 3m {signed(peRow?.velocity?.["3m"])}</p>
        </div>
      </div>
      {series.length > 1 ? (
        <Suspense fallback={<div style={{ height: 125 }} className="flex items-center justify-center text-[10px] text-slate-600">Loading premium trace…</div>}>
          <div className="grid grid-cols-1 gap-3 lg:grid-cols-5">
            <div className="lg:col-span-3">
              <PremiumChart series={series} />
            </div>
            <div className="lg:col-span-2">
              <p className="mb-1 px-1 text-[9px] font-bold text-slate-500">SPOT · {fmtPrice(data?.spot, 1)}</p>
              <SpotChart series={series} />
            </div>
          </div>
        </Suspense>
      ) : <EmptyData label="Premium history appears after two live chain updates" />}
    </div>
  );
});

export default PremiumTracker;
